import { Typography } from '../../../typography/Typography';
import { ErrorMessageProps } from './types';

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
    if (!message || typeof message !== 'string') {
        return null;
    }

    return (
        <Typography
            variant="body"
            color="var(--badge-rejected)"
            textAlign="center"
            width="100%"
            mt={2}
            style={{ fontSize: '14px' }}
        >
            {message}
        </Typography>
    );
};
